import { render, staticRenderFns } from "./DrawerMenuCamadasAtivas.vue?vue&type=template&id=66b27104&lang=pug"
import script from "./DrawerMenuCamadasAtivas.vue?vue&type=script&lang=js"
export * from "./DrawerMenuCamadasAtivas.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenuCamadasAtivas.vue?vue&type=style&index=0&id=66b27104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports